import { normalizeProviderName } from '@/lib/observability/client/trackers/wallet-connection/tracker'

/** Minimal shape of a wagmi connector needed to identify the wallet provider. */
type ConnectorLike = { id?: string; name?: string } | undefined

// Normalized provider id (e.g. 'ledger') — shared with the connection metrics normalizer.
export const getWalletProvider = (connector?: ConnectorLike): string =>
  normalizeProviderName(connector?.id, connector?.name)

// EIP-6963 rdns announced by the Ledger Wallet Provider button (verified in the
// SDK dist: `info.rdns`). wagmi surfaces this rdns as `connector.id`, so matching
// it identifies the billed button exactly — not the Ledger browser extension
// (`com.ledger…`) or a Ledger device used through another wallet, which a fuzzy
// `'ledger'` substring match would wrongly attribute to the per-deposit deal.
export const LEDGER_WALLET_PROVIDER_RDNS = 'com.ledger.wallet.provider'

// True only for the EIP-6963 Ledger Wallet Provider button (the billed connector).
export const isLedgerWalletProvider = (connector?: ConnectorLike): boolean =>
  connector?.id === LEDGER_WALLET_PROVIDER_RDNS
